import { Fonts } from '@qirapagos/lib/theme'
import styled from 'styled-components'
import {
  gray,
  white,
  black,
  errorSec,
  grayLight,
  graySec,
  purpleSec,
  violet,
  green,
  greenLight,
  greenBorder,
  error
} from 'theme/colors'
import React from 'react'
import { DEVICES } from 'theme/devicesSizes'

export const Container = styled.div<{
  width?: string | number
  height?: string | number
}>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 5px;
  padding: 24px 24px 16px 24px;
  background-color: ${white};
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  ${({ width }) => width && `width: ${width};`}
  ${({ height }) => height && `height: ${height};`}
  transition: all 0.3s ease;
`

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 0.75rem;
  align-items: center;
`

export const AmountContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 16px;
  @media ${DEVICES.mobile} {
    height: 80px;
  }
`

export const EyeButton = styled.button`
  display: flex;
  margin-left: 21px;
`

export const BalanceWithNoDecimals = styled.div`
  font-size: 28.61px;
  font-family: ${Fonts.POPPINS_MED};
  font-weight: 600;
  @media ${DEVICES.mobile} {
    font-size: 24px;
  }
`

export const BalanceDecimals = styled.div`
  align-self: flex-start;
  margin-top: 7px;
  font-size: 12px;
  font-family: ${Fonts.POPPINS_MED};
  font-weight: 600;
  @media ${DEVICES.mobile} {
    margin-top: 26px;
  }
`

export const Title = styled.p`
  font-size: 15px;
  font-weight: 500;
  color: ${gray};
  @media ${DEVICES.mobile} {
    font-size: 10px;
  }
`

export const Subtitle = styled.p`
  font-size: 16px;
  font-weight: 500;
  color: ${gray};
`

export const BalanceHoldingErrorText = styled.p`
  font-size: 14px;
  font-weight: 500;
  font-style: italic;
  color: ${black};
`

export const BottomContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: auto;
  margin-bottom: 4px;
`

export const InvestmentButton = styled.button<{ $disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: flex-end;
  width: 111px;
  height: 34px;
  background-color: ${({ $disabled }) => ($disabled ? '#F2ECFB' : purpleSec)};
  color: ${({ $disabled }) => ($disabled ? '#C8B8E8' : violet)};
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  border: none;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  transition: opacity 0.2s, background-color 0.2s, color 0.2s;

  &:hover {
    opacity: ${({ $disabled }) => ($disabled ? 1 : 0.9)};
  }
`

export const Performance = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${green};
`

export const PerformanceValue = styled.p`
  font-size: 8px;
  font-weight: 500;
  color: ${black};
`

const getTriangleStyle = (isNegative: boolean) => ({
  width: 0,
  height: 0,
  borderLeftWidth: 3.5,
  borderRightWidth: 3.5,
  borderLeftColor: 'transparent',
  borderRightColor: 'transparent',
  marginRight: 2,
  ...(isNegative
    ? { borderTopWidth: 5, borderTopColor: black }
    : { borderBottomWidth: 5, borderBottomColor: black })
})

const getPerformanceBoxStyle = (
  value: number | undefined
): React.CSSProperties => ({
  flexDirection: 'row',
  alignItems: 'center',
  borderWidth: 1.5,
  paddingLeft: 6,
  paddingRight: 6,
  paddingTop: 2,
  paddingBottom: 2,
  marginLeft: 8,
  borderRadius: 4,
  ...(value && value > 0
    ? { backgroundColor: greenLight, borderColor: greenBorder }
    : value && value < 0
      ? { backgroundColor: errorSec, borderColor: error }
      : { backgroundColor: grayLight, borderColor: graySec })
})

export { getTriangleStyle, getPerformanceBoxStyle }
